import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Navbar from '@components/Navbar/Navbar';
import Footer from '@components/Footer/Footer';
import styles from './MainLayout.module.css';

/**
 * Shared page shell.
 * Navbar and Footer persist across routes;
 * page content renders via <Outlet />.
 *
 * On the home page the Navbar is transparent and overlays
 * the hero, so no extra top spacing is needed.
 */
export default function MainLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  /* Scroll to top on route change */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return (
    <div className={styles.layout}>
      <Navbar />
      <main className={`${styles.main} ${isHome ? styles.homeMain : ''}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
